module.exports = __webpack_public_path__ + "static/media/cloud.064de008.svg";